export default __webpack_public_path__ + "static/media/twc-80x80.524c0bc6.webp";